export default {
  en: {
    PAGE_TITLE: 'Multi-Factor Authentication',
    TABLE_LOADING: 'Loading your multi-factor authentication methods.',
    ADD_MFA_METHOD: 'Enable Multi-Factor Authentication',
    MFA_ACTIONS_UPDATE: 'Update multi-factor authentication',
    MFA_METHODS_TABLE_EMPTY: 'You haven\'t enabled multi-factor authentication yet.'
  }
};